import { render, staticRenderFns } from "./SkillButton.vue?vue&type=template&id=22d7f94c&scoped=true"
import script from "./SkillButton.vue?vue&type=script&lang=js"
export * from "./SkillButton.vue?vue&type=script&lang=js"
import style0 from "./SkillButton.vue?vue&type=style&index=0&id=22d7f94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7f94c",
  null
  
)

export default component.exports